export type Notes = {
  id: number;
  title: string;
  url: string;
  likes: number;
  rating: number;
  views: number;
  vote_count: number;
  instruments: {
    code: string;
    title: string;
  }[];
  img: {
    src: string;
    src_256_362: string;
  };
  complexity: {
    level: 10 | 20 | 30;
    title: string;
  } | null;
  musicians: {
    title: string;
    url: string;
  }[];
  variants?: {
    BASE?: string;
    MIDI?: string;
  };
  arrangement: {
    id: string;
    code: string;
    title: string;
  };
};
